<template>
  <div></div>
</template>


<script>
import VectorImageLayer from "ol/layer/VectorImage";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import Projection from "ol/proj/Projection";
import { Fill, Stroke, Style, Text } from "ol/style";
import Feature from "ol/Feature";
import Circle from "ol/geom/Circle";
import * as proj from "ol/proj";
import proj4 from "proj4";

export default {
  name: "ManageLayer",
  props: {
    id: String,
  },
  methods: {
    styleHighlight(style) {
      if (style.fill_.color_ !== null) {
        let color = style.fill_.color_;
        let colorArr = color.split(",");
        colorArr[3] = "0.2)";
        color = colorArr.toString();
        let styleD = new Style({
          fill: new Fill({
            color: color,
          }),
          stroke: new Stroke({
            color: "yellow", //'#319FD3',
            width: 2,
          }),
          // text: new Text()
        });
        return styleD;
      } else {
        return style;
      }
    },
    styleDisabled(style) {
      if (style.fill_.color_ !== null) {
        let color = style.fill_.color_;
        let colorArr = color.split(",");
        colorArr[3] = "0.3)";
        color = colorArr.toString();
        let styleD = new Style({
          fill: new Fill({
            color: color,
          }),
          stroke: new Stroke({
            color: "rgba(255, 255, 255, 0.3)",
            width: 1,
          }),
          text: new Text("Disabled"),
        });
        return styleD;
      } else {
        return style;
      }
    },
    setColors() {
      this.legendColors = this.$store.getters.legendColors;
    },
    setStyleDef() {
      this.legendColors = this.$store.getters.legendColors;
      let stroke = new Stroke({
        // color : '#319FD3',
        // color: 'rgba(200, 200, 200, 0.2)',
        color: "rgba(80, 80, 80, 0.7)",
        // color : '#cccccc',
        width: 1,
      });

      for (let i = 0; i <= 10; i++) {
        this.style_def[i] = new Style({
          stroke: stroke,
          fill: new Fill({ color: this.legendColors[i] }),
        });
      }
    },
    getCenterOfExtent: function (Extent) {
      var X = Extent[0] + (Extent[2] - Extent[0]) / 2;
      var Y = Extent[1] + (Extent[3] - Extent[1]) / 2;
      return [X, Y];
    },
    getLayerSource() {
      // let TL = this.$store.getters.TL
      let params = this.$route.params;
      let TL = params.tl;
      //console.log(TL)
      // this.$store.commit('delAllPolygons')
      this.polygons = null;
      if (TL === "TL3") {
        if (!this.polygons_tl3) {
          let tl3_data = this.$store.getters.objTL3;

          // this.polygons_tl3 = new VectorSource()
          this.polygons_tl3 = new VectorSource({
            features: new GeoJSON({
              featureProjection: "EPSG:3857",
              dataProjection: "EPSG:4326",
            }).readFeatures(tl3_data),
          });
          this.polygons_tl3NorthAmerica = new VectorSource({
            features: new GeoJSON({
              featureProjection: this.$store.getters.NorthAmericaProjection,
              dataProjection: "EPSG:4326",
            }).readFeatures(tl3_data),
          });
          this.polygons_tl3Europe = new VectorSource({
            features: new GeoJSON({
              featureProjection: this.$store.getters.EuropeProjection,
              dataProjection: "EPSG:4326",
            }).readFeatures(tl3_data),
          });

          let gj = new GeoJSON().readFeatures(tl3_data);
          console.log(gj);
          for (let g of gj) {
            let e = g.getGeometry().getExtent();
            // console.log(g.getProperties())
            // let centerLongitudeLatitude = proj.fromLonLat([e[0], e[1]])
            const projection = new Projection({
              code: "EPSG:3857",
              extent: e,
            });
            let centerLongitudeLatitude = proj.fromLonLat(
              this.getCenterOfExtent(e),
              projection
            );
            let feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            feature.getGeometry().setRadius(400000);
            let style = new Style({
              fill: new Fill({
                // color: 'rgba(255, 255, 255, 0.8)'
                color: "rgba(12, 30, 210, 0.3)",
              }),
              stroke: new Stroke({
                color: "#319FD3",
                width: 10,
              }),
              text: new Text(),
            });
            feature.setStyle(style);
            // feature.set('COUNTRY', f['country'])
            // feature.set('NAME', f['name'])
            // feature.set('CODE', f['id'])
            feature.set("pop", 10000);
            feature.set("COUNTRY", g.getProperties().COUNTRY);
            feature.set("NAME", g.getProperties().NAME);
            feature.set("CODE", g.getProperties().CODE);
            this.polygons_tl3.addFeature(feature);

            const projection2 = this.$store.getters.EuropeProjection;
            let centerLongitudeLatitude2 = proj.fromLonLat(
              this.getCenterOfExtent(e),
              projection2
            );
            let feature2 = new Feature(new Circle(centerLongitudeLatitude2, 1));
            feature2.getGeometry().setRadius(400000);
            feature2.setStyle(style);
            feature2.set("pop", 10000);
            feature2.set("COUNTRY", g.getProperties().COUNTRY);
            feature2.set("NAME", g.getProperties().NAME);
            feature2.set("CODE", g.getProperties().CODE);
            this.polygons_tl3Europe.addFeature(feature2);

            const projection3 = this.$store.getters.NorthAmericaProjection;
            let centerLongitudeLatitude3 = proj.fromLonLat(
              this.getCenterOfExtent(e),
              projection3
            );
            let feature3 = new Feature(new Circle(centerLongitudeLatitude3, 1));
            feature3.getGeometry().setRadius(400000);
            feature3.setStyle(style);
            feature3.set("pop", 10000);
            feature3.set("COUNTRY", g.getProperties().COUNTRY);
            feature3.set("NAME", g.getProperties().NAME);
            feature3.set("CODE", g.getProperties().CODE);
            this.polygons_tl3NorthAmerica.addFeature(feature3);
          }
          console.log(this.polygons_tl3);
        }
        this.$store.commit("set_current_polygons", this.polygons_tl3);
        this.$store.commit(
          "set_current_polygonsNorthAmerica",
          this.polygons_tl3NorthAmerica
        );
        this.$store.commit(
          "set_current_polygonsEurope",
          this.polygons_tl3Europe
        );
        return [
          this.polygons_tl3,
          this.polygons_tl3Europe,
          this.polygons_tl3NorthAmerica,
        ];
      } else if (TL === "TL2") {
        if (!this.polygons_tl2) {
          let tl2_data = this.$store.getters.objTL2;
          console.log(tl2_data);

          // this.polygons_tl2 = new VectorSource()

          this.polygons_tl2 = new VectorSource({
            features: new GeoJSON({
              featureProjection: "EPSG:3857",
              dataProjection: "EPSG:4326",
            }).readFeatures(tl2_data),
          });

          this.polygons_tl2NorthAmerica = new VectorSource({
            features: new GeoJSON({
              featureProjection: this.$store.getters.NorthAmericaProjection,
              dataProjection: "EPSG:4326",
            }).readFeatures(tl2_data),
          });
          this.polygons_tl2Europe = new VectorSource({
            features: new GeoJSON({
              featureProjection: this.$store.getters.EuropeProjection,
              dataProjection: "EPSG:4326",
            }).readFeatures(tl2_data),
          });

          let gj = new GeoJSON().readFeatures(tl2_data);
          console.log(gj);
          for (let g of gj) {
            let e = g.getGeometry().getExtent();
            // console.log(g.getProperties())
            const projection = new Projection({
              code: "EPSG:3857",
              extent: e,
            });
            let centerLongitudeLatitude = proj.fromLonLat(
              this.getCenterOfExtent(e),
              projection
            );

            let feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            feature.getGeometry().setRadius(400000);
            let style = new Style({
              fill: new Fill({
                // color: 'rgba(255, 255, 255, 0.8)'
                color: "rgba(12, 30, 210, 0.3)",
              }),
              stroke: new Stroke({
                color: "#319FD3",
                width: 10,
              }),
              text: new Text(),
            });
            feature.setStyle(style);
            feature.set("pop", 1000000);
            feature.set("COUNTRY", g.getProperties().COUNTRY);
            feature.set("NAME", g.getProperties().NAME);
            feature.set("CODE", g.getProperties().CODE);
            this.polygons_tl2.addFeature(feature);

            const projection2 = this.$store.getters.EuropeProjection;
            let centerLongitudeLatitude2 = proj.fromLonLat(
              this.getCenterOfExtent(e),
              projection2
            );
            let feature2 = new Feature(new Circle(centerLongitudeLatitude2, 1));
            feature2.getGeometry().setRadius(400000);
            feature2.setStyle(style);
            feature2.set("pop", 10000);
            feature2.set("COUNTRY", g.getProperties().COUNTRY);
            feature2.set("NAME", g.getProperties().NAME);
            feature2.set("CODE", g.getProperties().CODE);
            this.polygons_tl2Europe.addFeature(feature2);

            const projection3 = this.$store.getters.NorthAmericaProjection;
            let centerLongitudeLatitude3 = proj.fromLonLat(
              this.getCenterOfExtent(e),
              projection3
            );
            let feature3 = new Feature(new Circle(centerLongitudeLatitude3, 1));
            feature3.getGeometry().setRadius(400000);
            feature3.setStyle(style);
            feature3.set("pop", 10000);
            feature3.set("COUNTRY", g.getProperties().COUNTRY);
            feature3.set("NAME", g.getProperties().NAME);
            feature3.set("CODE", g.getProperties().CODE);
            this.polygons_tl2NorthAmerica.addFeature(feature3);
          }
          console.log(this.polygons_tl2);
        }
        this.$store.commit("set_current_polygons", this.polygons_tl2);
        this.$store.commit(
          "set_current_polygonsNorthAmerica",
          this.polygons_tl2NorthAmerica
        );
        this.$store.commit(
          "set_current_polygonsEurope",
          this.polygons_tl2Europe
        );
        return [
          this.polygons_tl2,
          this.polygons_tl2Europe,
          this.polygons_tl2NorthAmerica,
        ];
      } else if (TL === "FUA" && params.tu === "x") {
        if (!this.polygons_FUA_x) {
          this.polygons_FUA_x = new VectorSource();
          this.polygons_FUA_xNorthAmerica = new VectorSource();
          this.polygons_FUA_xEurope = new VectorSource();
          for (let f of this.$store.getters.FUA) {
            let coordinates = [f["lon"], f["lat"]];
            let centerLongitudeLatitude = proj.fromLonLat(coordinates);
            let feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_FUA_x.addFeature(feature);

            centerLongitudeLatitude = proj4(
              "EPSG:3857",
              "ESRI:102009",
              proj.fromLonLat(coordinates)
            );
            feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_FUA_xNorthAmerica.addFeature(feature);

            centerLongitudeLatitude = proj4(
              "EPSG:3857",
              "EPSG:3035",
              proj.fromLonLat(coordinates)
            );
            feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_FUA_xEurope.addFeature(feature);
          }
        }
        this.$store.commit("set_current_polygons", this.polygons_FUA_x);
        this.$store.commit(
          "set_current_polygonsNorthAmerica",
          this.polygons_FUA_xNorthAmerica
        );
        this.$store.commit(
          "set_current_polygonsEurope",
          this.polygons_FUA_xEurope
        );

        return [
          this.polygons_FUA_x,
          this.polygons_FUA_xEurope,
          this.polygons_FUA_xNorthAmerica,
        ];
      } else if (TL === "FUA" && params.tu !== "x") {
        // if (!this.polygons_FUA_y) {
        let fua_data = this.$store.getters.objFUA;
        console.log(fua_data);
        this.polygons_FUA_y = new VectorSource({
          features: new GeoJSON({
            featureProjection: "EPSG:3857",
            dataProjection: "EPSG:3857",
          }).readFeatures(fua_data),
        });
        // }

        let tableFUACities = this.$store.getters.TableFUACities;

        console.log(params.tu)

        // tableFUACities = tableFUACities[params.tu + "F"];
        tableFUACities = tableFUACities[params.tu];
        let cities = this.$store.getters.CY;
        for (let f of tableFUACities) {
          // console.log(f)
          // let id = f.substring(0, f.length - 1);
          let id = f;
          for (let c of cities) {
            // console.log(c.id)
            // console.log(id)
            // console.log('=========')
            if (c.id === id) {
              console.log(c.lat);
              console.log(c.lon);
              console.log(c.name);

              let coordinates = [c.lon, c.lat];
              // let coordinates = [5452428.659054539, 190384.5949568921]

              let centerLongitudeLatitude = proj.fromLonLat(coordinates);
              console.log(centerLongitudeLatitude);
              let feature = new Feature(new Circle(centerLongitudeLatitude, 1));
              // let feature = new Feature(new Circle([190384.5949568921, 5452428.659054539 ]))

              feature.set("COUNTRY", c.name);
              feature.set("NAME", c.name);
              feature.set("CODE", id);
              feature.set("fuacode", id + "F");
              feature.set("fuaname_en", c.name);
              feature.set("pop", c.name);
              feature.set("isCity", true);
              feature.set("noclick", true);

              let rad = 130000;
              feature.getGeometry().setRadius(rad);
              this.polygons_FUA_y.addFeature(feature);
              let style = new Style({
                fill: new Fill({
                  // color: 'rgba(255, 255, 255, 0.8)'
                  color: "rgba(12, 30, 210, 0.5)",
                }),
                stroke: new Stroke({
                  color: "rgba(12, 30, 210, 0.3)",
                  width: 30,
                }),
                text: new Text("PIPPO"),
              });
              feature.setStyle(style);

              /*
                let centerLongitudeLatitude = proj.fromLonLat(coordinates);  
                let feature = new Feature(new Circle(centerLongitudeLatitude, 1))
                let rad =  10000
                feature.getGeometry().setRadius(rad)
                feature.set('COUNTRY', f['country'])
                feature.set('NAME', c.name)
                feature.set('CODE', id)
                feature.set('pop', c.name)
                let style = new Style({
                    fill: new Fill({
                      // color: 'rgba(255, 255, 255, 0.8)'
                      color: 'rgba(12, 30, 210, 0.3)'
                    }),
                    stroke: new Stroke({
                      color: '#319FD3',
                      width: 10
                    }),
                    text: new Text()
                  })
              feature.setStyle(style)
              this.polygons_EFUA_y.addFeature(feature)
*/
            }
          }
        }
        // Aggiungere al verttore poligono i cerchi delle cities

        this.$store.commit("set_current_polygons", this.polygons_FUA_y);
        return [this.polygons_FUA_y];
      } else if (TL === "EFUA" && params.tu === "x") {
        if (!this.polygons_EFUA_x) {
          this.polygons_EFUA_x = new VectorSource();
          this.polygons_EFUA_xNorthAmerica = new VectorSource();
          this.polygons_EFUA_xEurope = new VectorSource();

          for (let f of this.$store.getters.EFUA) {
            let coordinates = [f["lon"], f["lat"]];
            let centerLongitudeLatitude = proj.fromLonLat(coordinates);
            let feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            let rad = parseInt(parseInt(f["pop"]) / 300 + 10000);
            feature.getGeometry().setRadius(rad);
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_EFUA_x.addFeature(feature);

            centerLongitudeLatitude = proj4(
              "EPSG:3857",
              "ESRI:102009",
              proj.fromLonLat(coordinates)
            );
            feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            rad = parseInt(parseInt(f["pop"]) / 300 + 10000);
            feature.getGeometry().setRadius(rad);
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_EFUA_xNorthAmerica.addFeature(feature);

            centerLongitudeLatitude = proj4(
              "EPSG:3857",
              "EPSG:3035",
              proj.fromLonLat(coordinates)
            );
            feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            rad = parseInt(parseInt(f["pop"]) / 300 + 10000);
            feature.getGeometry().setRadius(rad);
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_EFUA_xEurope.addFeature(feature);
          }
        }
        this.$store.commit("set_current_polygons", this.polygons_EFUA_x);
        this.$store.commit(
          "set_current_polygonsNorthAmerica",
          this.polygons_EFUA_xNorthAmerica
        );
        this.$store.commit(
          "set_current_polygonsEurope",
          this.polygons_EFUA_xEurope
        );
        return [
          this.polygons_EFUA_x,
          this.polygons_EFUA_xEurope,
          this.polygons_EFUA_xNorthAmerica,
        ];
      } else if (TL === "CY" && params.tu === "x") {
        if (!this.polygons_CY_x) {
          this.polygons_CY_x = new VectorSource();
          this.polygons_CY_xNorthAmerica = new VectorSource();
          this.polygons_CY_xEurope = new VectorSource();

          for (let f of this.$store.getters.CY) {
            let coordinates = [f["lon"], f["lat"]];
            let centerLongitudeLatitude = proj.fromLonLat(coordinates);
            let feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            let rad = parseInt(parseInt(f["pop"]) / 300 + 10000);
            feature.getGeometry().setRadius(rad);
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_CY_x.addFeature(feature);

            centerLongitudeLatitude = proj4(
              "EPSG:3857",
              "ESRI:102009",
              proj.fromLonLat(coordinates)
            );
            feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            rad = parseInt(parseInt(f["pop"]) / 300 + 10000);
            feature.getGeometry().setRadius(rad);
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_CY_xNorthAmerica.addFeature(feature);

            centerLongitudeLatitude = proj4(
              "EPSG:3857",
              "EPSG:3035",
              proj.fromLonLat(coordinates)
            );
            feature = new Feature(new Circle(centerLongitudeLatitude, 1));
            rad = parseInt(parseInt(f["pop"]) / 300 + 10000);
            feature.getGeometry().setRadius(rad);
            feature.set("COUNTRY", f["country"]);
            feature.set("NAME", f["name"]);
            feature.set("CODE", f["id"]);
            feature.set("pop", f["pop"]);
            this.polygons_CY_xEurope.addFeature(feature);
          }
        }
        this.$store.commit("set_current_polygons", this.polygons_CY_x);
        this.$store.commit(
          "set_current_polygonsNorthAmerica",
          this.polygons_CY_xNorthAmerica
        );
        this.$store.commit(
          "set_current_polygonsEurope",
          this.polygons_CY_xEurope
        );
        return [
          this.polygons_CY_x,
          this.polygons_CY_xEurope,
          this.polygons_CY_xNorthAmerica,
        ];
      } else if (TL === "EFUA" && params.tu !== "x") {
        // if (this.polygons_EFUA_y) {
        let cities_data = this.$store.getters.objEFUA;
        this.polygons_EFUA_y = new VectorSource({
          features: new GeoJSON({
            featureProjection: "EPSG:3857",
            dataProjection: "EPSG:3857",
          }).readFeatures(cities_data),
        });
        this.$store.commit("set_current_polygons", this.polygons_EFUA_y);
        return [this.polygons_EFUA_y];
        // }
      } else if (TL === "CY" && params.tu !== "x") {
        let cities_data = this.$store.getters.objCY;
        this.polygons_CY_y = new VectorSource({
          features: new GeoJSON({
            featureProjection: "EPSG:3857",
            dataProjection: "EPSG:3857",
          }).readFeatures(cities_data),
        });
        this.$store.commit("set_current_polygons", this.polygons_CY_y);
        return [this.polygons_CY_y];
        // }
      }
      // this.$store.commit('set_current_polygons', this.polygons)
      // return this.polygons
    },
    //setLayerSource(map) {
    //  if (map) {
    //    var l = map.getLayers().getArray()[2]
    //    l.setSource(this.getLayerSource())
    //  }
    //},
    manage_layers() {
      // console.log("******* >>> manage_layers")
      this.$root.$once("component_refresh", () => {
        this.manage_layers();
      });
      this.thresholds = this.$store.getters.legendThresholds;
      let style = new Style({
        fill: new Fill({
          // color: 'rgba(255, 255, 255, 0.8)'
          color: "rgba(12, 30, 210, 0.3)",
        }),
        stroke: new Stroke({
          color: "#319FD3",
          width: 1,
        }),
        text: new Text(),
      });

      // let polygon_layer = this.$store.getters.polygon_layer
      // if (!polygon_layer){
      let sources = this.getLayerSource();
      for (let source of sources) {
        let polygon_layer = new VectorImageLayer({
          imageRatio: 2,
          source: source,
          style: function () {
            return style;
          },
        });
        this.manage_country_polygon(polygon_layer);
      }
      // this.$root.$once('component_refresh', () => {this.manage_layers()})
      // }
    },
    get_style(value) {
      /*
        if (!value) {
          value = -1
        } else {
          value = parseInt(value)
        }
        */
      let style_ret = null;
      // console.log(value)
      if (isNaN(value)) {
        // console.log(value)
        value = -1000000;
      }
      /*
        if (!value) {
          value = -1
        } else {
          value = parseFloat(value)
        }
        */
      value = parseFloat(value);

      // console.log(this.$store.getters.all.ds.legendType)
      let legendType = this.$store.getters.all.ds.legendType;

      let len = this.thresholds.length;
      style_ret = this.style_def[9];
      if (legendType === "single") {
        for (let t = 0; t < len; t++) {
          if (value === this.thresholds[t]) {
            style_ret = this.style_def[t];
            return style_ret;
            // break
          }
        }
      } else {
        for (var t = len - 2; t >= 0; t--) {
          if (value >= this.thresholds[t]) {
            style_ret = this.style_def[t];
            return style_ret;
            // break
          }
        }
      }

      return style_ret;
    },
    manage_country_polygon(polygon_layer) {
      console.log("******* >>> manage_country_polygon");
      this.$store.commit("setshow_overlay", true);
      this.thresholds = this.$store.getters.legendThresholds;
      let country_id = this.$store.getters.countryID;
      let TU = this.$store.getters.TU;
      let TL = this.$store.getters.TL;
      let parent_TU = "";
      if ((TL === "TL3") & (TU !== "")) {
        let TL2 = this.$store.getters.getTL2ByName(TU);
        if (TL2) {
          parent_TU = TL2.code;
        }
      }
      //console.log('manage_country_polygon >' + TL + '<>' +country_id + '<>' + TU + '<>' + parent_TU + '<');
      // let polygon_layer = this.$store.getters.polygon_layer
      // console.log(polygon_layer)
      /*
        let style_transp = new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.6)'
          }),
          stroke: new Stroke({
            color: '#0d71a1',
            width: 1
          }),
          text: new Text()
        })
        */
      let ds = this.$store.getters.ds;
      this.legendColors = this.$store.getters.legendColors;
      this.setStyleDef();

      this.lastTL = this.$store.getters.TL;
      this.lastIndicator = this.$store.getters.indicator;
      let atts_code;
      let n = 0;

      if (polygon_layer) {
        // let FUASpop = this.$store.getters.FUASpopulation
        let year = this.$store.getters.year.toString();
        try {
          polygon_layer.getSource().forEachFeature((feature) => {
            let atts = feature.getProperties();
            // console.log(feature)
            // console.log(feature.values_.geometry)
            let value = 0;
            // let year = "2018"
            // console.log(year)
            if (n < 3) {
              n++;
              //console.log(atts)
              //console.log(feature.getGeometry().getType())
            }
            try {
              // let style = this.get_style(0)

              let style = new Style({
                fill: new Fill({
                  // color: 'rgba(255, 255, 255, 0.8)'
                  color: "rgba(225, 225, 225, 1)",
                }),
                stroke: new Stroke({
                  color: "rgba(233, 248, 255, 1)",
                  width: 1,
                }),
                text: new Text(),
              });

              if (feature.getGeometry().getType() === "Circle") {
                let pop = 0;
                let radius = 0;
                if (TL === "EFUA" || TL === "CY") {
                  try {
                    value = parseFloat(ds.dataset[year][atts.CODE]);
                  } catch (error) {
                    // console.log(error)
                    value = 0;
                  }
                } else {
                  try {
                    // let year = this.$store.getters.year.toString()
                    // value = ds.Data({METRO_ID: atts.CODE, TIME_PERIOD: year}).value
                    value = parseFloat(ds.dataset[year][atts.CODE]);
                    // pop  = FUASpop.Data({METRO_ID: atts.CODE, TIME_PERIOD: year}).value
                    // pop  = FUASpop.Data({METRO_ID: atts.CODE, TIME_PERIOD: "2018"}).value
                    // console.log(pop)
                    pop = parseInt(atts.pop);
                    // console.log(pop)
                  } catch (error) {
                    value = 0;
                    pop = 0;
                  }
                  if (pop) {
                    radius = Math.min(parseInt(pop / 100) + 20000, 300000);
                  }
                }
                if (TL !== "EFUA" && TL !== "CY") {
                  feature.getGeometry().setRadius(radius);
                }
                style = this.get_style(value);
              } else {
                if (TL === "FUA") {
                  value = parseFloat(ds.dataset[year][atts.fuacode]);
                } else if (TL === "EFUA") {
                  value = parseFloat(ds.dataset[year][atts.eFUA_ID]);
                } else if (TL === "CY") {
                  console.log(atts);
                  let code = atts.citycode;
                  code = code.substring(0, code.length - 1);
                  console.log(code);
                  console.log(ds.dataset[year]);
                  value = parseFloat(ds.dataset[year][code]);
                  console.log(value);
                } else if (TL === "TL2" || TL === "TL3") {
                  value = parseFloat(ds.dataset[year][atts.CODE]);
                } else {
                  try {
                    // let year = this.$store.getters.year.toString()
                    value = ds.Data({ REG_ID: atts.CODE, TIME: year }).value;
                  } catch (error) {
                    value = 0;
                  }
                }
                // style = this.get_style(0)
              }
              //console.log(value)
              let forceShow = false;
              if (TL === "FUA") {
                let query = this.$route.query;
                if (query.showzero === "false" || query.showzero === false) {
                  if (isNaN(value)) {
                    style = new Style(null);
                  }
                }
              }
              if (TU !== "") {
                if (TL === "FUA") {
                  console.log(atts);
                  atts_code = atts.fuacode.substring(
                    0,
                    atts.fuacode.length - 1
                  );
                  if (atts.isCity) {
                    forceShow = true;
                  }
                } else if (TL === "EFUA") {
                  atts_code = atts.eFUA_ID;
                } else if (TL === "CY") {
                  let code = atts.citycode;
                  code = code.substring(0, code.length - 1);
                  atts_code = code;
                } else {
                  atts_code = atts.CODE;
                }

                if (parent_TU !== "") {
                  atts_code = atts.PARENT;
                  TU = parent_TU;
                }
                // console.log(atts_code)
                // console.log(TU)
                if (TL !== "FUA" && TL !== "EFUA" && TL !== "CY") {
                  if (atts_code == TU) {
                    // feature.setStyle(style)
                    console.log("*** SHOW STYLE ***");
                    feature.setStyle(this.styleHighlight(style));
                  } else {
                    // console.log(style_transp)
                    // feature.setStyle(style_transp)
                    // feature.setStyle(new Style({}))
                    if (!forceShow) {
                      feature.setStyle(this.styleDisabled(style));
                    }
                  }
                }
              } else {
                if (country_id === "") {
                  feature.setStyle(style);
                } else {
                  if (atts.COUNTRY === country_id) {
                    // feature.setStyle(style)
                    feature.setStyle(this.styleHighlight(style));
                  } else {
                    // feature.setStyle(style_transp)
                    // feature.setStyle(new Style({}))
                    feature.setStyle(this.styleDisabled(style));
                  }
                }
              }
            } catch (error) {
              console.log(error);
            }
          });
          this.$store.commit("setpolygon_layer", polygon_layer);
          this.$store.commit("setshow_overlay", false);
        } catch (error) {
          console.log(error);
          this.$store.commit("setshow_overlay", false);
        }
      }
    },
  },
  beforeDestroy() {
    this.$root.$off("component_refresh", () => {});
    this.$root.$off("manage_layers", () => {});
    this.$root.$off("manage_country_polygon", () => {});
    //this.$root.$off('set_layer_source', () => {})
  },
  mounted() {
    //console.log("**** ManageLayer MOUNTED ****")
    this.$root.$once("component_refresh", () => {
      this.manage_layers();
    });
    this.setColors();
    this.setStyleDef();
    /*
      this.$root.$on('manage_layers', () => {
          this.manage_layers()
      })
      this.$root.$on('manage_country_polygon', () => {
          this.manage_country_polygon()
      })
      */
    //this.$root.$on('set_layer_source', (map) => {
    //    this.setLayerSource(map)
    //})
    /*
      this.$root.$on('component_refresh', () => {
          this.manage_layers()
      })
      */
  },
  data: () => ({
    lastTL: "",
    lastIndicator: "",
    thresholds: [],
    legendColors: [],
    cpl: "",
    style_def: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ],
  }),
};
</script>
